<template>
  <div>
    <EmailQueue />
  </div>
</template>

<script>
import EmailQueue from "@@/SuperAdminEmailQueue/EmailQueue.vue";

export default {
  name: "AdminSuperCommunications",

  components: { EmailQueue }
};
</script>
